var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success Checkmark"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333333,
    y: 0.333333,
    width: 31.3333,
    height: 31.3333,
    rx: 15.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 29.3334C23.3641 29.3334 29.3337 23.3639 29.3337 16.0001C29.3337 8.63629 23.3641 2.66675 16.0003 2.66675C8.63653 2.66675 2.66699 8.63629 2.66699 16.0001C2.66699 23.3639 8.63653 29.3334 16.0003 29.3334ZM22.123 12.6141C22.4621 12.1781 22.3836 11.5498 21.9476 11.2108C21.5117 10.8717 20.8834 10.9502 20.5443 11.3862L15.2016 18.2553C15.0828 18.4081 14.8594 18.4279 14.7155 18.2985L11.336 15.2568C10.9255 14.8874 10.2932 14.9207 9.92371 15.3312C9.55425 15.7417 9.58753 16.374 9.99804 16.7434L13.3776 19.785C14.3845 20.6912 15.9487 20.5524 16.7804 19.4832L22.123 12.6141Z",
    fill: "#298700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.333333,
    y: 0.333333,
    width: 31.3333,
    height: 31.3333,
    rx: 15.6667,
    stroke: "#298700",
    strokeWidth: 0.666667
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckmark);
export default __webpack_public_path__ + "static/media/Success_Checkmark.cf0cd7ac0e22f43c5b2883f7e4297dc8.svg";
export { ForwardRef as ReactComponent };